export default "__VITE_ASSET__6FUW6nWk__"